import { render, staticRenderFns } from "./ReturnRequestPopup.vue?vue&type=template&id=fb502358&"
import script from "./ReturnRequestPopup.vue?vue&type=script&lang=js&"
export * from "./ReturnRequestPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports